import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import Base from '../base.entity';

@Entity('items')
export default class Item extends Base {
	static tableName = 'items';

	@PrimaryGeneratedColumn()
	id: number;

	@Column('varchar')
	mobile_id: string;

	@Column('int')
	prod_id: number;

	@Column('int')
	episodic_item_id: number;

	@Column('int')
	char_id: number;

	@Column('varchar')
	name: string;

	@Column('varchar')
	brand: string;

	@Column('int')
	type_name: number;

	@Column('varchar')
	color: string;

	@Column('varchar')
	description: string;

	@Column('varchar')
	size: string;

	@Column('decimal')
	actual_price: string;

	@Column('decimal')
	approx_price: string;

	@Column('decimal')
	budget: string;

	@Column('varchar')
	purchase_source: string;

	@Column('int')
	purchase_type: number;

	@Column('varchar')
	purchase_sku: string;

	@Column('varchar')
	rental_house: string;

	@Column('varchar')
	rental_barcode: string;

	@Column('varchar')
	vendor: string;

	@Column('varchar')
	vendor_contact: string;

	@Column('varchar')
	promo_source: string;

	@Column('varchar')
	promo_contact: string;

	@Column('varchar')
	item_url: string;

	@Column('varchar')
	item_count: string;

	@Column('varchar')
	notes: string;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column('int')
	last_updated_user: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@Column('int')
	created_by: number;

	static rules() {
		return {
			id: Joi.number().integer(),
			mobile_id: Joi.string().max(36).allow(null, ''),
			prod_id: Joi.number().integer().allow(null),
			episodic_item_id: Joi.number().integer().allow(null),
			char_id: Joi.number().integer().allow(null),
			name: Joi.string().max(1000).allow(null),
			brand: Joi.string().max(1000).allow(null),
			type_name: Joi.number().integer().allow(null),
			color: Joi.string().max(500).allow(null),
			description: Joi.string().max(1000).allow(null),
			size: Joi.string().max(300).allow(null),
			actual_price: Joi.string().max(11).allow(null),
			approx_price: Joi.string().max(11).allow(null),
			budget: Joi.string().max(11).allow(null),
			purchase_source: Joi.string().max(300).allow(null),
			purchase_type: Joi.number().integer().allow(null),
			purchase_sku: Joi.string().max(100).allow(null),
			rental_house: Joi.string().max(100).allow(null),
			rental_barcode: Joi.string().max(100).allow(null),
			vendor: Joi.string().max(100).allow(null),
			vendor_contact: Joi.string().max(100).allow(null),
			promo_source: Joi.string().max(100).allow(null),
			promo_contact: Joi.string().max(100).allow(null),
			item_url: Joi.string().max(2000).allow(null),
			item_count: Joi.string().max(1000).allow(null),
			notes: Joi.string().max(1000).allow(null),
			last_updated_time: Joi.date().allow(null),
			last_updated_user: Joi.number().integer(),
			date_created: Joi.date().allow(null),
			created_by: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			id: this.id,
			mobile_id: this.mobile_id,
			prod_id: this.prod_id,
			episodic_item_id: this.episodic_item_id,
			char_id: this.char_id,
			name: this.name,
			brand: this.brand,
			type_name: this.type_name,
			color: this.color,
			description: this.description,
			size: this.size,
			actual_price: this.actual_price,
			approx_price: this.approx_price,
			budget: this.budget,
			purchase_source: this.purchase_source,
			purchase_type: this.purchase_type,
			purchase_sku: this.purchase_sku,
			rental_house: this.rental_house,
			rental_barcode: this.rental_barcode,
			vendor: this.vendor,
			vendor_contact: this.vendor_contact,
			promo_source: this.promo_source,
			promo_contact: this.promo_contact,
			item_url: this.item_url,
			item_count: this.item_count,
			notes: this.notes,
			last_updated_time: this.last_updated_time,
			last_updated_user: this.last_updated_user,
			date_created: this.date_created,
			created_by: this.created_by,
		};
	}

	assign(props?: GenPartial<Item>) {
		super.assign(props);

		if (props) {
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	constructor(props?: GenPartial<Item>) {
		super(props);
	}
}
